export const filterEmptyParam = (attributeName) => (params) => {
  const { [attributeName]: attr, ...remParams } = params;
  return attr ? params : remParams;
};
